<template lang="pug">
div
  daes-periodo
  daes-municipio(v-if="!isLoading", :municipios="municipios", :receitas="receitas")
  daes-tipo-processo(v-if="!isLoading", :municipios="municipios", :receitas="receitas")
</template>

<script>
import DaesPeriodo from '@/screens/financeiro/relatoriosDae/DaesPeriodo.vue'
import DaesMunicipio from '@/screens/financeiro/relatoriosDae/DaesMunicipio.vue'
import DaesTipoProcesso from '@/screens/financeiro/relatoriosDae/DaesTipoProcesso.vue'
import { mapActions } from 'vuex'

export default {
  components: {
    DaesPeriodo,
    DaesMunicipio,
    DaesTipoProcesso
  },

  async created () {
    this.isLoading = true
    this.municipios = await this.getMunicipios()
    this.receitas = await this.getReceitas()
    this.isLoading = false
  },

  computed: {
  },

  methods: {
    ...mapActions({
      getMunicipios: 'municipios/findMunicipiosByEstadoAtual',
      getReceitas: 'receitas/getReceitas'
    })
  },

  data () {
    return {

      municipios: [],
      receitas: [],
      isLoading: false
    }
  }

}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/screens/financeiro/relatoriosDae/RelatoriosDae.vue